import './style.scss'
import { Layout } from 'antd'
import { FC, memo } from 'react'
import { Outlet } from 'react-router-dom'
import CouponTip from '../CouponTip'
import NewUserTip from '../NewUserTip'
import LayoutHeader from './components/header'
import LayoutMenu from './components/menu'

const LayoutIndex: FC = () => {
  return (
    <div className="layout-index">
      <CouponTip />
      <NewUserTip />
      <div className="layout-container">
        <LayoutMenu></LayoutMenu>
        <Layout.Content>
          <LayoutHeader />
          <Outlet></Outlet>
        </Layout.Content>
      </div>
    </div>
  )
}

export default memo(LayoutIndex)
